import { HubConnection } from '@microsoft/signalr'
import { BooleanField, Datagrid, InfiniteList, NumberField, TextField, TopToolbar, useRefresh, useTranslate } from 'react-admin'

interface IProps {
  connection?: HubConnection
}

const InvoiceReminderList = ({connection} : IProps) => {

  const refresh = useRefresh()
  connection?.on('InvoiceReminderUpdated', () => { refresh() })
  const translate = useTranslate()

  return (
    <InfiniteList actions={<TopToolbar/>} sort={{field: "createdAt", order: "DESC"}} >
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source='textModel.heading' label='resources.invoiceReminders.heading' sortable={false} />
        <TextField source="invoiceRecipient.company.companyName" label={'resources.company.companyName'} sortable={false} />
        <BooleanField source="isSendByMail" label='resources.invoiceReminders.isSendByMail' sortable={false} />
        <NumberField label={translate("resources.invoices.comment", {smart_count: 2})} source="comments.length" emptyText="0" sortable={false} />
      </Datagrid>
    </InfiniteList>
  )
}

export default InvoiceReminderList